const Style = {

  // ── Container ────────────────────────────────────────────────────────────────
  container:    'bg-white rounded-xl border border-gray-200 overflow-hidden',
  scroll:       'overflow-x-auto',
  table:        'w-full border-collapse text-sm',

  // ── Header ───────────────────────────────────────────────────────────────────
  thead:        'border-b border-gray-100',
  th:           'py-3 px-4 text-left font-semibold text-[11px] text-gray-500 whitespace-nowrap bg-white tracking-[0.05em] select-none uppercase',
  thSortBtn:    'inline-flex items-center gap-1 cursor-pointer',
  thLabel:      'inline-flex items-center gap-1',
  sortBase:     'text-[11px]',
  sortActive:   'text-gray-700',
  sortInactive: 'text-gray-300',

  // ── Body ─────────────────────────────────────────────────────────────────────
  row:          'border-b border-gray-50 hover:bg-gray-50',
  cell:         'py-3 px-4 text-gray-700',
  empty:        'py-10 text-center text-gray-400',

  // ── Pagination ────────────────────────────────────────────────────────────────
  pagination:     'flex justify-between items-center py-3 px-4 border-t border-gray-100',
  pageSizeGroup:  'flex items-center gap-2 text-sm text-gray-500',
  pageSizeSelect: 'border border-gray-200 rounded py-1 px-2 text-sm text-gray-700 bg-white cursor-pointer',
  pageCtrlGroup:  'flex items-center gap-1.5 text-sm text-gray-500',
  pageInput:      'w-12 border border-gray-200 rounded py-1 px-1.5 text-sm text-center',
  pageBtnBase:    'border border-gray-200 rounded py-1 px-2 text-sm bg-transparent',
  pageBtnOn:      'cursor-pointer text-gray-700 hover:bg-gray-50',
  pageBtnOff:     'cursor-default text-gray-300',

};

export default Style;
